export default {
    // called by Vue.use(FirstPlugin)
    install(Vue) {
        Vue.prototype.$notificarError = (mensaje) => {
            const errorData = getErrorData(mensaje);
            Vue.notify(errorData);
        }
    }
}

function getErrorData(mensaje) {
    return {
        group: "gral_notif",
        type: "error",
        duration: 1500,
        speed: 500,
        text: mensaje
    }
}